// Dynamic filter function
export const createFilteredList = ({
  dataList,
  searchTerm,
  searchLookupKeys = [],
}) => {
  if (!searchTerm?.trim() || searchLookupKeys?.length === 0) {
    return dataList;
  }

  const lowercaseSearchTerm = searchTerm.toLowerCase();

  return dataList.filter((item) => {
    return searchLookupKeys.some((key) => {
      const value = item[key];

      // Handle null/undefined values
      if (value === null || value === undefined) {
        return false;
      }

      // Handle arrays
      if (Array.isArray(value)) {
        return value.some((arrayItem) => {
          if (arrayItem === null || arrayItem === undefined) return false;
          return String(arrayItem).toLowerCase().includes(lowercaseSearchTerm);
        });
      }

      // Handle objects (search in nested properties)
      if (typeof value === "object") {
        const objectString = JSON.stringify(value).toLowerCase();
        return objectString.includes(lowercaseSearchTerm);
      }

      // Handle primitive values (string, number, boolean)
      return String(value).toLowerCase().includes(lowercaseSearchTerm);
    });
  });
};
